import {Injectable} from '@angular/core';
import {Platform} from '@ionic/angular';
import {from, noop, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { IziviaLoggerService } from './iziviaLogger.service';

@Injectable({
    providedIn: 'root'
})
export class IziviaPlatformService {

    constructor(private readonly platform: Platform,
        private readonly loggerService: IziviaLoggerService) {
    }

    ready(): Observable<void> {
        return from(this.platform.ready())
            .pipe(
                map(readySource => noop())
            );
    }

    get(): Platform {
        return this.platform;
    }

    /**
     * This is a TERMINAL operation! Further actions may not worked as expected.
     * In most cases, you should not call this method directly but use restart method in IziviaNavigationService
     * instead.
     */
    reload(): void {
        this.loggerService.debug('[IziviaPlatformService] Reloading app!');
        window.location.reload();
    }
}
